<style>
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="supplier" class="label"> {{ $t("supplier") }}</label>
                                <app-input 
                                    v-model="inputs.supplier"
                                    type="text" 
                                    :placeholder="$t('supplier')"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="supplier_address" class="label"> {{ $t("supplier_address") }}</label>
                                <app-input 
                                    v-model="inputs.address"
                                    type="textarea" 
                                    :placeholder="$t('supplier_address')"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="packer" class="label"> {{ $t("packer") }}</label>
                                <app-input 
                                    type="text" 
                                    v-model="inputs.packer"
                                    :placeholder="$t('packer')"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="packer_fda" class="label"> {{ $t("packer_fda") }}</label>
                                <app-input 
                                    type="text" 
                                    v-model="inputs.packer_fda"
                                    :placeholder="$t('packer_fda')"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="payment" class="label"> {{ $t("payment") }}</label>
                                <app-input 
                                    type="text" 
                                    v-model="inputs.payment"
                                    :placeholder="$t('payment')"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="terms" class="label"> {{ $t("terms") }}</label>
                                <app-input 
                                    type="text" 
                                    v-model="inputs.terms"
                                    :placeholder="$t('terms')"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="supplier_price" class="label"> {{ $t("supplier_price") }}</label>
                                <app-input 
                                    type="text" 
                                    v-model="inputs.price"
                                    :placeholder="$t('supplier_price')"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row"> -->
                    <!-- <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="redirectToCustomer">
                            {{ $t('continue') }}
                        </button>
                    </div> -->
                <!-- </div> -->
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { get_data } from '../mixins/api.js';

export default {
    name: "add_contractDetail_form",
    mixins: [FormMixin],
    data() {
        return {
            inputs: {
                supplier : null,
                address : null,
                packer : null,
                packer_fda : null,
                payment : null,
                terms : null,
                price : null
            },
            preloader : false,
        }  
    },
    methods: {

        redirectToCustomer(){
            this.$hub.$emit('change-tab-subtab', 'tab-3');
        },

        async loadData(id) {
            if (id) {
                const respuesta = await get_data(id);
                this.inputs = { ...this.inputs, ...respuesta };
            }
            this.preloader = false;
        },
    },

    watch : {
        inputs : {
            deep : true,
            handler(newVal){
            }
        }
    },

    props: {
        props: { type: Object, default: () => ({}) }
    },

    mounted() {    
        this.contractId = this.props.id; 
        if (this.contractId) {
            this.preloader = true;
            this.loadData(this.contractId);
        }
    },
}
</script>
